import {AbilityType} from "./Type";

export const onChangeAbility = (ability) => ({
    type: AbilityType.ON_CHANGE_ABILITY,
    payload: ability
})